"use client";

// KAN-975: сообщения, нужные только разделу турниров (145 групп, 16% словаря), — отдельным чанком на
// локаль (см. shared/i18n/messages-layer). Файл на локаль, чтобы в чанк попадал только свой язык.
// Файл сгенерирован: pnpm run messages:split.
import type { ReactNode } from "react";

import { MessagesLayer } from "../messages-layer";

import tournaments from "../../../../messages/generated/ru.tournaments.json";

export function TournamentsMessagesRu({ children }: { children: ReactNode }) {
  return <MessagesLayer extra={tournaments}>{children}</MessagesLayer>;
}
